import EditModalVM from './modal-vm'

export default {
  init(){
    const el = document.getElementById('mobile_modal_edit_attendance')

    if (el) {
      const vm = new EditModalVM()
      ko.applyBindings(vm, el)
    }
  }
}

